import { useSync } from '../contexts/SyncContext';
import './SyncStatusBar.css';

const STATE_LABELS = {
  fresh: 'Daten aktuell',
  syncing: 'Synchronisiert …',
  offline: 'Offline',
  never: 'Noch nicht synchronisiert',
  stale: 'Daten veraltet',
};

export default function SyncStatusBar() {
  const { state, syncing, progress } = useSync();
  const label = syncing && progress.message
    ? progress.message
    : STATE_LABELS[state] || STATE_LABELS.fresh;

  return (
    <div
      className={`sync-status-bar sync-status-bar--${state}`}
      role="status"
      aria-live="polite"
      aria-label={label}
      title={label}
    />
  );
}
